var $ui = (function () {
  function getURLParams() {
    var result = {}
    var q = location.href.split('?')
    var params = []
    var i
    var slice

    if (q.length < 2) {
      return {}
    } else {
      q = q[1]
    }

    if (q.indexOf('#') > -1) {
      q = q.split('#')[0]
    }

    params = q.split('&')

    for (i = 0; i < params.length; i++) {
      slice = params[i].split('=')
      slice[1] = slice[1] || ''
      result[slice[0]] = decodeURIComponent(slice[1])
    }

    return result
  }

  function tabChange() {
    var $links = $('.rules-tab a')
    var $tabContents = $('.rules')
    var hash = location.hash
    var hashList = []

    //hash
    if (hash.indexOf('?') > 0) {
      hash = hash.split('?')[0]
    } else if (hash.indexOf('&') > 0) {
      hash = hash.split('&')[0]
    } else if (hash.indexOf('/') > 0) {
      hash = hash.split('/')[0]
    }

    $links.each(function () {
      hashList.push($(this).attr('href'))
    })

    $links.on('click', function (e) {
      var id = $(this).attr('href')

      e.preventDefault()
      $links.parent().removeClass('on')
      $(this).parent().addClass('on')

      $tabContents.hide()
      $(id).show()
    })

    //deeplink
    var hashIdx = hashList.indexOf(hash)
    hashIdx > 0 ? $links.eq(hashIdx).click() : $links.eq(0).click()
  }

  function init() {
    var $body = $('body')
    var parameters = getURLParams()

    // header = on | off
    // closebtn = on | off
    // view = terms | operational | privacy
    if (parameters.header === 'off') {
      $body.addClass('header-off')
    } else if (parameters.header === 'on') {
      $('.rules-header h1').html('피망 모바일 게임 이용약관')
      $body.removeClass('header-off').addClass('header-on')
    } else {
      $body.removeClass('header-off').addClass('header-on')
    }

    if (parameters.closebtn === 'off') {
      $body.addClass('closebtn-off')
    }

    if (parameters.view) {
      var viewId = /(terms|operational|privacy)/.test(parameters.view)
        ? parameters.view
        : 'terms'

      $body.addClass('single-view')
      $('#' + viewId).show()
    } else {
      $body.removeClass('single-view')
      tabChange()
    }
  }

  function tocGenerator(traget, tags, toContainer) {
    var $target = $(traget)
    var $tags = $target.find(tags)
    var $toc = $('<div class="toc"></div>')
    var $link = $('<a></a>')
    var key = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(0, 5)

    $.each($tags, function (i) {
      var newId = key + '-' + i

      $(this).attr('id', newId)

      $link
        .clone()
        .attr({ href: '#' + newId })
        .text($(this).text())
        .appendTo($toc)
    })

    if (toContainer) {
      $toc.appendTo($(toContainer))
    } else {
      $toc.prependTo($target)
    }
  }

  return {
    init: init,
    toc: tocGenerator,
  }
})()

$(function () {
  $ui.init()
})
